<template>
  <div>
    <v-row class="mx-2">
      <v-col cols="12" md="8" class="flex-items">
        <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
          <v-tab
            v-for="tab in tabList"
            :key="tab.id"
            @change="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        md="4"
        class="d-flex justify-between-center align-center"
      >
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg mx-2"
          color="#239FAB"
          dense
        ></v-text-field>
        <v-autocomplete
          v-model="selectedCalendarYear"
          @change="initialize()"
          dense
          outlined
          hide-details
          class="rounded-lg"
          :item-text="(item) => item.yearFrom + ' - ' + item.yearTo"
          item-value="id"
          label="ILPD Calendar Year"
          color="#6DB249"
          :items="ildpCalendarList"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="tab == 1 ? headers : headers1"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:[`item.yearFrom`]="{ item }">
          {{ item.yearFrom + " - " + item.yearTo }}
        </template>

        <template v-slot:[`item.head_approval_status`]="{ item }">
          <div v-if="item.head_approver">
            <div v-if="item.shouldBeUpdated">
              <v-chip v-if="item.is_submitted == 0" class="ma-2" x-small>
                For Submission
              </v-chip>
              <v-chip
                v-if="item.is_submitted == 1 && item.head_approval_status == 1"
                class="ma-2"
                x-small
              >
                For Approval
              </v-chip>
              <v-icon
                color="#519043"
                v-if="item.is_submitted == 1 && item.head_approval_status == 2"
                >mdi-check-bold</v-icon
              >

              <v-icon
                color="error"
                v-if="item.is_submitted == 1 && item.head_approval_status == 3"
                >mdi-timer-refresh-outline</v-icon
              >
            </div>
            <div v-else>
              <v-chip
                v-if="item.head_approval_status == 1"
                class="ma-2"
                x-small
              >
                For Approval
              </v-chip>
              <v-icon color="#519043" v-if="item.head_approval_status == 2"
                >mdi-check-bold</v-icon
              >

              <v-icon color="error" v-if="item.head_approval_status == 3"
                >mdi-timer-refresh-outline</v-icon
              >
            </div>
          </div>
        </template>

        <template v-slot:[`item.dean_approval_status`]="{ item }">
          <div v-if="item.dean_approver">
            <div v-if="item.shouldBeUpdated">
              <v-chip v-if="item.is_submitted == 0" class="ma-2" x-small>
                For Submission
              </v-chip>
              <v-chip
                v-if="item.is_submitted == 1 && item.dean_approval_status == 1"
                class="ma-2"
                x-small
              >
                For Approval
              </v-chip>
              <v-icon
                color="#519043"
                v-if="item.is_submitted == 1 && item.dean_approval_status == 2"
                >mdi-check-bold</v-icon
              >

              <v-icon
                color="error"
                v-if="item.is_submitted == 1 && item.dean_approval_status == 3"
                >mdi-timer-refresh-outline</v-icon
              >
            </div>
            <div v-else>
              <v-chip
                v-if="item.dean_approval_status == 1"
                class="ma-2"
                x-small
              >
                For Approval
              </v-chip>
              <v-icon color="#519043" v-if="item.dean_approval_status == 2"
                >mdi-check-bold</v-icon
              >

              <v-icon color="error" v-if="item.dean_approval_status == 3"
                >mdi-timer-refresh-outline</v-icon
              >
            </div>
          </div>
        </template>
        <template v-slot:[`item.vp_approval_status`]="{ item }">
          <div v-if="item.vp_approver">
            <div v-if="item.shouldBeUpdated">
              <v-chip v-if="item.is_submitted == 0" class="ma-2" x-small>
                For Submission
              </v-chip>
              <v-chip
                v-if="item.is_submitted == 1 && item.vp_approval_status == 1"
                class="ma-2"
                x-small
              >
                For Approval
              </v-chip>
              <v-icon
                color="#519043"
                v-if="item.is_submitted == 1 && item.vp_approval_status == 2"
                >mdi-check-bold</v-icon
              >

              <v-icon
                color="error"
                v-if="item.is_submitted == 1 && item.vp_approval_status == 3"
                >mdi-timer-refresh-outline</v-icon
              >
            </div>
            <div v-else>
              <v-chip v-if="item.vp_approval_status == 1" class="ma-2" x-small>
                For Approval
              </v-chip>
              <v-icon color="#519043" v-if="item.vp_approval_status == 2"
                >mdi-check-bold</v-icon
              >

              <v-icon color="error" v-if="item.vp_approval_status == 3"
                >mdi-timer-refresh-outline</v-icon
              >
            </div>
          </div>
        </template>

        <template v-slot:[`item.president_approval_status`]="{ item }">
          <div v-if="item.shouldBeUpdated">
            <v-chip v-if="item.is_submitted == 0" class="ma-2" x-small>
              For Submission
            </v-chip>
            <v-chip
              v-if="
                item.is_submitted == 1 && item.president_approval_status == 1
              "
              class="ma-2"
              x-small
            >
              For Approval
            </v-chip>
            <v-icon
              color="#519043"
              v-if="
                item.is_submitted == 1 && item.president_approval_status == 2
              "
              >mdi-check-bold</v-icon
            >

            <v-icon
              color="error"
              v-if="
                item.is_submitted == 1 && item.president_approval_status == 3
              "
              >mdi-timer-refresh-outline</v-icon
            >
          </div>
          <div v-else>
            <v-chip
              v-if="item.president_approval_status == 1"
              class="ma-2"
              x-small
            >
              For Approval
            </v-chip>
            <v-icon color="#519043" v-if="item.president_approval_status == 2"
              >mdi-check-bold</v-icon
            >

            <v-icon color="error" v-if="item.president_approval_status == 3"
              >mdi-timer-refresh-outline</v-icon
            >
          </div>
        </template>
        <template v-slot:[`item.submitted_date`]="{ item }">
          {{ formatDate(item.submitted_date) }}
        </template>
        <template v-slot:[`item.hr_received_date`]="{ item }">
          {{ formatDate(item.hr_received_date) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn x-small color="grey" outlined @click="editItem(item)">
            <v-icon size="14">mdi-eye</v-icon> View
          </v-btn>
          <v-btn
            x-small
            color="#519043"
            class="mx-1"
            outlined
            v-if="tab == 2"
            @click="printItem(item)"
          >
            <v-icon size="14">mdi-printer</v-icon> Print
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>
      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <ViewILDP :data="updateData" :tab="tab" :action="action" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Confirmation </v-card-title>

        <v-card-text style="font-size: 17px">
          Are you sure you want to delete this item ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="teal darken-3"
            outlined
            @click="dialogConfirmDelete = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="teal darken-3"
            class="white--text"
            @click="
              confirmDelete();
              dialogConfirmDelete = false;
            "
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  components: {
    ViewILDP: () => import("../../components/Dialogs/Views/ViewILDP.vue"),
  },

  data: () => ({
    search: "",
    headers: [
      { text: "Name", value: "name", align: "start" },
      { text: "Calendar Year", value: "yearFrom", align: "center" },
      {
        text: "Immediate Head",
        value: "head_approval_status",
        align: "center",
      },
      {
        text: "Dean/Director",
        value: "dean_approval_status",
        align: "center",
      },
      { text: "Vice President", value: "vp_approval_status", align: "center" },
      {
        text: "President",
        value: "president_approval_status",
        align: "center",
      },
      {
        text: "Date submitted",
        value: "submitted_date",
        align: "center",
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headers1: [
      { text: "Name", value: "name", align: "start" },
      { text: "Calendar Year", value: "yearFrom", align: "center" },
      {
        text: "Immediate Head",
        value: "head_approval_status",
        align: "center",
      },
      {
        text: "Dean/Director",
        value: "dean_approval_status",
        align: "center",
      },
      { text: "Vice President", value: "vp_approval_status", align: "center" },
      {
        text: "President",
        value: "president_approval_status",
        align: "center",
      },
      {
        text: "Date submitted",
        value: "submitted_date",
        align: "center",
      },
      {
        text: "Date Received",
        value: "hr_received_date",
        align: "center",
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    activeTab: { id: 1, name: "To Receive" },
    tab: 1,
    tabList: [
      { id: 1, name: "To Receive" },
      { id: 2, name: "Received" },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    updateData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    ildpCalendarList: [],
    selectedCalendarYear: null,
    work_dates_menu: false,
    dialogConfirmDelete: false,
    approver: null,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.getILDPCalendarYear();
    this.eventHub.$on("closeViewILDP", () => {
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewILDP");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      setTimeout(() => {
        this.axiosCall(
          "/my-ildp/received/" + this.tab + "/" + this.selectedCalendarYear,
          "GET",
        ).then((res) => {
          if (res) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.data = data;
            this.loading = false;
          }
        });
      }, 1000);
    },

    getILDPCalendarYear() {
      this.axiosCall("/ildp-calendar-year", "GET").then((res) => {
        if (res) {
          let data = res.data;
          data.sort((a, b) => b.id - a.id);
          this.ildpCalendarList = data;
          this.selectedCalendarYear = data[0].id;
        }
      });
    },
    changeTab(tab) {
      this.activeTab = tab;

      this.tab = tab.id;
      this.initialize();
    },
    add() {
      this.updateData = [{ id: null }];
      this.action = "Add";
    },
    editItem(item) {
      console.log(item);
      this.updateData = item;
      this.action = "Update";
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },

    printItem(item) {
      console.log(item);

      let url =
        process.env.VUE_APP_SERVER + "/pdf-generator/printILDP/" + item.id;

      let token = localStorage.getItem("token");
      const tabs = window.open("about:blank");
      this.printLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } }) // FETCH BLOB FROM IT
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tabs.location = _url;

          this.printLoading = false; // window.open + focus
          tabs.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
